export const API_BANNER_FIELDS = [
    'banners.id',
    'banners.status',
    'banners.sort',
    'banners.translations',
    'banners.page',
    'banners.show_button',
    'banners.button_pdf',
    'banners.only_title',
    'banners.desktop_image.id',
    'banners.mobile_image.id',
    'banners.vertical_position_desktop',
    'banners.horizontal_position_desktop',
    'banners.vertical_position_mobile',
    'banners.horizontal_position_mobile',
    'banners.button_image.id'
];
